// extracted by mini-css-extract-plugin
module.exports = {"tagInputContainer":"TagInput_tagInputContainer","tagInputAdd":"TagInput_tagInputAdd","tagInputItem":"TagInput_tagInputItem","tagInputItemDelete":"TagInput_tagInputItemDelete"};